import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchBarComponent } from 'src/app/modules/shared/search-bar/search-bar.component';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-fullscreen-layout',
  templateUrl: './fullscreen-layout.component.html',
  styleUrls: ['./fullscreen-layout.component.scss'],
  animations: [
    trigger('toggleMenu', [
      state('closed', style({
        height: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
      })),
      state('open', style({
        height: 'auto',
      })),
      transition('closed=>open', animate('300ms')),
      transition('open=>closed', animate('300ms'))
    ])
  ]
})
export class FullscreenLayoutComponent implements OnInit {
  @Input() isMenuHidden;

  vh;
  isSticky = false;
  isLoggedInStatic = false;
  isMobileMenuOpen = false;
  isMobileNotificationsOpen = false;

  @HostListener('window:resize', ['$event'])
  checkResize() {
    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
    this.isLoggedInStatic = this.authService.isAuthenticated();
  }

  isLanding() {
    return this.route.snapshot.url.length === 0;
  }

  isLoggedIn() {
    return this.authService.isAuthenticated();
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/');
  }

  openSearch() {
    const dialogRef = this.dialog.open(SearchBarComponent);
  }

  getProfileName() {
    return this.authService.getUserFirstName().charAt(0).toUpperCase();
  }

  getProfileImage() {
    return this.authService.getUserImage();
  }
}